import React from "react";
import { IconMessageCircle } from "@tabler/icons-react";

import { SectionTitle } from "./";

export default function Comments({ comments = [], title = "Comments" }) {
  if (!comments.length) return null;

  return (
    <div className="comments">
      <SectionTitle title={title} large icon={<IconMessageCircle />} />
      <div className="comment-grid">
        {comments.map((c) => (
          <p key={c.id}>{c.text}</p>
        ))}
      </div>
    </div>
  );
}
